<template>
  <a-card>
    <g-master name="biodatainformacionacademica"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              :modalFieldsSetup="master.modalFieldsSetup"
              :parentData="evParentData"
    >
      <template slot="masterModal" slot-scope="{record}">
        <a-row :gutter="[16,16]">
        <a-col v-bind="colOptions">
          <g-dropdown endpoint="hierarchy_lookup"
                      :label="$t('Lenguaje')"
                      style="width: 100%"
                      :formItemConfig="fiOptions"
                      :decorator="['id_h_language', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                      :params="id_h_idioma">
          </g-dropdown>
        </a-col>
        <a-col v-bind="colOptions">
          <g-dropdown endpoint="hierarchy_lookup"
                      :formItemConfig="fiOptions"
                      style="width: 100%"
                      :label="$t('Escribe')"
                      :decorator="['id_h_writing', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                      :params="id_h_nivel_estudio">
          </g-dropdown>
        </a-col>
        <a-col v-bind="colOptions">
          <g-dropdown endpoint="hierarchy_lookup"
                      :formItemConfig="fiOptions"
                      style="width: 100%"
                      :label="$t('Lee')"
                      :decorator="['id_h_reading', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                      :params="id_h_nivel_estudio">
          </g-dropdown>
        </a-col>
        <a-col v-bind="colOptions">
          <g-dropdown endpoint="hierarchy_lookup"
                      :formItemConfig="fiOptions"
                      style="width: 100%"
                      :label="$t('Habla')"
                      :decorator="['id_h_speaking', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                      :params="id_h_nivel_estudio">
          </g-dropdown>
        </a-col>
        <a-col v-bind="colOptions">
        <a-form-item v-bind="fiOptions" :label="$t('Certificado')" :has-feedback="false">
          <a-checkbox v-decorator="['certificate', {valuePropName: 'checked'}]">
          </a-checkbox>
        </a-form-item>
        </a-col>
        </a-row>
      </template>
    </g-master>
  </a-card>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'

  export default {
    mounted () {
      this.httpClient = new HttpUtil()
    },
    data () {
      return {
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        id_h_idioma: {
          h_lookup_type: 'IDIOMAS'
        },
        id_h_nivel_estudio: {
          h_lookup_type: 'NIVEL_IDIOMA'
        },
        colOptions: {xs: 24, sm: 24},
        master: {
          endpoint: 'personlang',
          tableSetup: {
            tableConfig: {
              rowKey: 'id_person_lang'
            },
            columns: [
              {title: 'Lenguaje', dataIndex: 'h_language', sorter: true},
              {title: 'Habla', dataIndex: 'h_speaking', sorter: true},
              {title: 'Escribe', dataIndex: 'h_writing', sorter: true},
              {title: 'Lee', dataIndex: 'h_reading', sorter: true},
              {title: 'Certificado', dataIndex: 'certificado', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by'},
              {title: 'Creado el', dataIndex: 'created_on'},
              {title: 'Modificado por', dataIndex: 'modified_by'},
              {title: 'Modificado', dataIndex: 'modified_on'}
            ]
          },
          modalFieldsSetup: [
            {name: 'certificate', type: 'boolean'},
            {name: 'id_h_language'},
            {name: 'id_h_reading'},
            {name: 'id_h_speaking'},
            {name: 'id_h_writing'}
          ]
        }
      }
    },
    props: ['persona'],
    computed: {
      evParentData () {
        return {
          id_person: this.persona
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Biodata/BiodataIdiomaOtrosEstudiosIdiomas.vue